import { followSteps } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function FollowFlow() {
  return (
    <section id="follow" className="w-full py-14 md:py-20 bg-secondary-50 border-y border-secondary-100">
      <div className="w-full max-w-site mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="关注与私信"
          title="关注一个人，只需要三步"
          desc="关注是把公开的评论和动态串起来的线，私信是线下面的那一段悄悄话。两条路都不需要先互加好友。"
        />

        <div className="mt-9 grid grid-cols-1 md:grid-cols-3 gap-5">
          {followSteps.map((step, index) => (
            <div
              key={step.step}
              className={`animate-fade-up relative rounded-lg border border-secondary-100 bg-background-50 p-5 md:p-6 ${
                index === 1 ? "delay-100" : index === 2 ? "delay-200" : ""
              }`}
            >
              <div className="flex items-center justify-between">
                <span className="w-11 h-11 rounded-md bg-primary-50 text-primary-700 flex items-center justify-center">
                  <i className={`${step.icon} text-xl`}></i>
                </span>
                <span className="font-heading text-2xl font-bold text-accent-500">
                  {step.step}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base md:text-lg font-bold text-foreground-950">
                {step.title}
              </h3>
              <p className="mt-2.5 text-xs md:text-sm text-foreground-600 leading-relaxed">
                {step.desc}
              </p>
              {index < followSteps.length - 1 && (
                <span className="hidden md:flex absolute top-1/2 -right-3 w-6 h-6 items-center justify-center text-secondary-400">
                  <i className="ri-arrow-right-line"></i>
                </span>
              )}
            </div>
          ))}
        </div>

        <div className="mt-6 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6 rounded-lg border border-secondary-100 bg-background-50 p-4 md:p-5">
          <span className="w-10 h-10 shrink-0 rounded-md bg-secondary-100 text-secondary-800 flex items-center justify-center">
            <i className="ri-information-line text-lg"></i>
          </span>
          <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">
            私信默认只对互相关注的人开放，你可以随时在隐私设置里调整为「所有人可发」或「关闭私信」；关注列表和解绑操作也都在同一个面板里完成。
          </p>
          <a
            href="#faq"
            className="self-start sm:self-auto h-10 px-5 rounded-md border border-background-300 bg-background-50 text-sm font-medium text-foreground-900 inline-flex items-center gap-2 hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            看隐私设置说明
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}